import { useEffect, useState } from 'react'

// Starts false on the server and on the first client render, then follows the system setting.
export const usePrefersReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const query = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = (): void => setReduced(query.matches)

        update()
        query.addEventListener('change', update)

        return () => query.removeEventListener('change', update)
    }, [])

    return reduced
}
